import { DocSearch, version, } from '@docsearch/react';
import React from 'react';
import ReactDOM from 'react-dom';
import '@docsearch/css';
function getHTMLElement(value, environment = window) {
    if (typeof value === 'string') {
        return environment.document.querySelector(value);
    }
    return value;
}
const docsearch = React.createElement(DocSearch, { indexName: 'erlang', apiKey: "bf29f41417431fe16225fa8cde510744", transformSearchClient: (searchClient) => {
        searchClient.addAlgoliaAgent('docsearch.js', version);
        return searchClient;
    } });
const button = getHTMLElement('#docsearch');
ReactDOM.render(docsearch, button);
const mobile = getHTMLElement('#docsearch-mobile');
if (mobile) {
    mobile.addEventListener('click', () => {
        button.getElementsByTagName('button')[0].click();
    });
}
